import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'

const useStyles = makeStyles<Theme>((theme) => ({
  list: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 4,
  },
  row: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: 'none',
    display: 'grid',
    alignItems: 'center',
    // gridTemplateColumns: '116px max-content auto max-content',
    gridTemplateColumns: '116px 1px auto 32px',
    gridTemplateAreas: `
      "status separator name caret"
      "details details details details"
    `,
    gap: '0px 16px',
    '&:last-child': {
      borderRadius: '0px 0px 4px 4px',
    },
  },
  status: {
    display: 'grid',
    gap: 8,
    alignItems: 'center',
    gridTemplateColumns: '16px auto',
    gridArea: 'status',
    padding: '10px 0px 10px 16px',
  },
  separator: {
    width: '1px',
    height: 'calc(100% - 20px)',
    background: theme.palette.grey[200],
    gridArea: 'separator',
  },
  name: {
    gridArea: 'name',
    padding: '10px 0px',
  },
  caretContainer: {
    gridArea: 'caret',
    padding: '10px 16px 10px 0px',
  },
  caret: {
    fontSize: 12,
  },
  details: {
    gridArea: 'details',
    padding: '8px 40px',
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.grey[50],
  },
}))

export default function AccordionProgressList({
  items,
  renderStatus,
  renderName,
  renderDetails,
  uniqueIdentifier,
}) {
  const classes = useStyles()

  const [expandedItems, setExpandedItems] = useState({})

  const toggleExpand = (id) => {
    if (expandedItems[id]) {
      setExpandedItems({
        ...expandedItems,
        [id]: false,
      })
    } else {
      setExpandedItems({
        ...expandedItems,
        [id]: true,
      })
    }
  }

  return (
    <div className={classes.list}>
      {items?.map((item) => {
        const isExpanded = !!expandedItems[item?.[uniqueIdentifier]]
        return (
          <div key={item?.[uniqueIdentifier]} className={classes.row}>
            <div className={classes.status}>{renderStatus(item)}</div>
            <div className={classes.separator} />
            <div className={classes.name}>{renderName(item)}</div>
            <div className={classes.caretContainer}>
              {isExpanded ? (
                <FontAwesomeIcon
                  className={classes.caret}
                  onClick={() => toggleExpand(item?.[uniqueIdentifier])}
                  solid
                >
                  chevron-up
                </FontAwesomeIcon>
              ) : (
                <FontAwesomeIcon
                  className={classes.caret}
                  onClick={() => toggleExpand(item?.[uniqueIdentifier])}
                  solid
                >
                  chevron-down
                </FontAwesomeIcon>
              )}
            </div>
            {isExpanded && <div className={classes.details}>{renderDetails(item)}</div>}
          </div>
        )
      })}
    </div>
  )
}
